export default function DataCard(props) {
    return (
      <div className="DataCard">
        <h3>{props.title || '-'}</h3>
        <p>{props.count || 0}</p>
      </div>
    );
  }
  